import React from "react";
import { FilasEsperaProvider } from "./context/filas-espera-context";
import { FilasEspera } from "./filas-espera";
import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory";

const FilasEsperaFactory = () => {
    return (
        <BaseInternalFormFactory pageTitle={"Filas de Espera"}>
            <FilasEsperaProvider>
                <FilasEspera />
            </FilasEsperaProvider>
        </BaseInternalFormFactory>
    );
};

export default FilasEsperaFactory;
